module.exports = __webpack_public_path__ + "img/undo.b71ca570.svg";